import { isEqual, omit, isObject, set } from 'lodash';

function ignoreFilterProperties(filterObj, ignoreProperties) {
  return Object.keys(filterObj).reduce((agg, key) => {
    const obj = omit(filterObj[key], ignoreProperties);
    set(agg, key, obj);
    return agg;
  }, {});
}

function isDuplicateFilter(a, b, ignoreProperties = ['_order']) {
  if (isObject(a) && isObject(b)) {
    /* Ignore grandfather filter for finding duplicate filters with '_order' by default */
    const aFilter = ignoreFilterProperties(a, ignoreProperties);
    const bFilter = ignoreFilterProperties(b, ignoreProperties);
    return isEqual(aFilter, bFilter);
  }
  return false;
}

export default isDuplicateFilter;
